module.exports = __webpack_public_path__ + "img/beg.ba912edf.svg";